import { render } from "./Test.vue?vue&type=template&id=02368f5c"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=02368f5c&lang=less"
script.render = render

export default script